import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { toast } from 'react-toastify';
import { useTokens } from '../context/TokenContext';
import { API_URL } from '../constants';
import LoadingDashboardContent from '../components/LoadingDashboardContent';
import LoginModal from '../components/LoginModal';

const ProtectedRouteVendor = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const { getItem, setItem, isTokenExpired } = useTokens();
  const token = getItem('vendor', 'AuthToken');

  const loginUrl = `${API_URL}/vendor/login`;
  const heartbeatUrl = `${API_URL}/heartbeat`;

  // Initial token check
  useEffect(() => {
    const initAuthCheck = () => {
      if (!token || isTokenExpired(token)) {
        setIsAuthenticated(false);
        setShowModal(true);
      } else {
        setIsAuthenticated(true);
        setShowModal(false);
      }
      setLoading(false);
    };

    initAuthCheck();
  }, [token]);

  // Silent heartbeat every 60s
  useEffect(() => {
    const checkHeartbeatSilently = async () => {
      try {
        const response = await axios.get(heartbeatUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data?.message !== 'Token is valid.') {
          console.warn('Heartbeat failed. Token may be invalid.');
        } else {
          setItem('vendor', 'UserNotifications', response.data?.notifications || []);
        }
      } catch (err) {
        console.warn('Silent heartbeat failed:', err.message);
      }
    };

    if (token) {
      checkHeartbeatSilently();
    }
    
    const interval = setInterval(() => {
      if (token) {
        checkHeartbeatSilently();
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [token]);

  // Login modal success handler
  const handleLoginSuccess = (newToken, user) => {
    setItem('vendor', 'AuthToken', newToken);
    setItem('vendor', 'UserInfo', user);
    setIsAuthenticated(true);
    setShowModal(false);
  };

  if (loading) return <LoadingDashboardContent />;

  return (
    <>
      {isAuthenticated && children}
      {showModal && (
        <LoginModal
          show={true}
          userType="vendor"
          loginPath={loginUrl}
          onLogin={handleLoginSuccess}
        />
      )}
    </>
  );
};

export default ProtectedRouteVendor;
